import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    p('iniKatolikushittan');
    if ($('#q_teaching_places_id_eq').myGetNumValue()) {
      $('html,body').animate({
        scrollTop: $("#teachers").offset()!.top - 50
      }, 'fast');
    }
  }
}